export const selectButtonTheme = {
  root: {
    borderRadius: 'var(--border-radius)',
  },
};
